import React from "react";
import { Modal } from "flowbite-react";
import { Button } from "../buttons";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ModalHelp = ({ openModal, setOpenModal, children, size }) => {
  return (
    <Modal show={openModal} onClose={() => setOpenModal(false)} size={size} position="center" theme={tenkenTheme.modal_help}>
      <Modal.Header>凡例</Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
          <Button
            color="reset"
            className="min-w-[160px]"
            children="閉じる"
            onClick={() => setOpenModal(false)}
          />
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHelp;
